// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"z3-z","subtitle":"A3-z","wrapper":"B3-z","leftArrow":"C3-z","rightArrow":"D3-z"};